module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-75.01ef6ce6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-75.png
// module id = 3284
// module chunks = 11